import ConversionError from './conversionError'

import {
    Box,
    Modal
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import ButtonPrimary from "./ButtonPrimary";
import COLORS from '../styles/colors.json';

const ConversionSuccess = ({ data, handleButtonClick }) => {
    const STYLE = {
        position: 'absolute',
        width: '60%',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: COLORS.white,
        borderRadius: 2
    };

    const quote = data.quote;
    const option = data.option;

    const message = `Successfuly sent quote ${quote.quote_id}, option ${option} to be converted. Allow a few minutes for this to reflect in the system.`;
    return (
        <Box sx={STYLE} >
            <Box
                borderBottom={1}
                borderColor={COLORS.gray3}
                padding={1}
            >
                <h3>Submitted quote for coversion</h3>
            </Box>
            <div className="modal-content" >
                <Box fontSize={50} marginRight={2}>
                    <FontAwesomeIcon icon={faCircleCheck} />
                </Box>
                {message}
            </div>
            <Box
                padding={1}
                display='flex'
                justifyContent='flex-end'
            >
                <ButtonPrimary onClick={handleButtonClick}>
                    OK
                </ButtonPrimary>
            </Box>
        </Box>
    )
}


export default function ConversionModal(props) {
    const {
        data,
        open,
        handleClose,
        error
    } = props;


    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Box>
                {error ? (
                    <ConversionError
                        data={data}
                        error={error}
                        handleButtonClick={handleClose}
                    />
                ) : (
                    <ConversionSuccess 
                        data={data}
                        handleButtonClick={handleClose}
                />
                    )}
            </Box>
        </Modal>
    )    
}
